import React, { useEffect, useRef, useState } from 'react';

/**
 * Counts down to a fixed deadline (not by summing up intervals), so the
 * display stays correct even if the browser throttles timers in a background tab.
 */
const CountdownTimer = ({ initialTime, info, onExpire }) => {
    const deadline = useRef(Date.now() + initialTime);
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const onExpireRef = useRef(onExpire);

    useEffect(() => {
        onExpireRef.current = onExpire;
    }, [onExpire]);

    useEffect(() => {
        const timerId = setInterval(() => {
            const left = Math.max(0, deadline.current - Date.now());
            setTimeLeft(left);
            if (left <= 0) {
                clearInterval(timerId);
                if (onExpireRef.current) {
                    onExpireRef.current();
                }
            }
        }, 1000);

        return () => clearInterval(timerId);
    }, []);

    const formatTime = (milliseconds) => {
        const totalSeconds = Math.ceil(milliseconds / 1000);
        const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${minutes}:${seconds}`;
    };

    return (
        <div>
            {info} {formatTime(timeLeft)}
        </div>
    );
};

export default CountdownTimer;
